import { render, staticRenderFns } from "./other-sources-weightage.vue?vue&type=template&id=e9892888&"
import script from "./other-sources-weightage.vue?vue&type=script&lang=js&"
export * from "./other-sources-weightage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports